export default __webpack_public_path__ + "static/media/E2.29f24d6d.mp3";